module.exports = __webpack_public_path__ + "static/media/logo-wbuy.23628395.svg";